import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 text-xs font-medium text-accent-400 mb-3">
            <i className="ri-apps-2-line"></i>
            内容导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">分类索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按类型快速浏览海量影视资源</p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-9 gap-3 md:gap-4">
          {indexData.map((item) => (
            <div
              key={item.id}
              className="group p-4 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 text-center cursor-pointer"
            >
              <div className={`w-12 h-12 mx-auto flex items-center justify-center rounded-2xl mb-3 transition-colors ${
                item.color === 'accent' ? 'bg-accent-500/10 group-hover:bg-accent-500/15' : 'bg-primary-500/10 group-hover:bg-primary-500/15'
              }`}>
                <i className={`${item.icon} text-xl ${item.color === 'accent' ? 'text-accent-400' : 'text-primary-400'}`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">{item.title}</h3>
              <span className="text-xs text-foreground-500">{item.count.toLocaleString()}部</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}